import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUserDetails, updateUserProfile } from "../../actions/userAction";
import RightDash from "../../components/RightDash";
import EmployerWelcome from "../../components/EmployerWelcome";
import EmployerMenu from "../../components/EmployerMenu";
import Message from "../../components/Message";
import Signout from "../../components/Signout";
import Login from "../Login";
import "../../styles/dashboard.css";

const EmployerProfile = ({ history, resizeMenu, setResizeMenu }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);

  const { userInfo } = userLogin;

  const userDetails = useSelector((state) => state.userDetails);

  const { user, loading, error } = userDetails;

  const userUpdateProfile = useSelector((state) => state.userUpdateProfile);

  const {
    loading: profileloading,
    success,
    error: profileerror,
  } = userUpdateProfile;

  useEffect(() => {
    dispatch(getUserDetails());
  }, [getUserDetails]);

  useEffect(() => {
    if (user !== undefined && user !== null && Object.keys(user).length) {
      setName(user.name);
      setEmail(user.email);
    }
  }, [user]);

  if (!userInfo) {
    return <Login />;
  }

  if (userInfo && userInfo.role === "developer") {
    history.push("/developer/dashboard");
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(updateUserProfile(name, email));
  };

  return (
    <div className="dashboard">
      <EmployerMenu resizeMenu={resizeMenu} setResizeMenu={setResizeMenu} />
      <RightDash resizeMenu={resizeMenu} setResizeMenu={setResizeMenu}>
        {success && (
          <Message variant="success">Profile edit successful</Message>
        )}
        {profileerror && <Message variant="danger">{profileerror}</Message>}
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100 h-100">
            <div className="spinner-blue"></div>
          </div>
        ) : error ? (
          <Message variant="danger">
            {error} <a href="/employer/profile">refresh page</a>
          </Message>
        ) : (
          <div className="right-wrapper">
            <EmployerWelcome />
            <div className="main p-3">
              <div>
                <h4 className="font-medium mb-2">Employer Information</h4>
                <div className="form-wrapper">
                  <form onSubmit={handleSubmit}>
                    <div className="mb-1">
                      <label className="mb-25 d-inline-block">Name</label>
                      <div className="dashinput">
                        <input
                          type="text"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="mb-1">
                      <label className="mb-25 d-inline-block">
                        Email Address
                      </label>
                      <div className="dashinput">
                        <input
                          type="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="my-2">
                      <button
                        className="d-flex justify-content-center button"
                        type="submit">
                        {profileloading ? (
                          <div className="spinner"></div>
                        ) : (
                          "SUBMIT"
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}
      </RightDash>
    </div>
  );
};

export default EmployerProfile;
